import { render, staticRenderFns } from "./CustomerTab.vue?vue&type=template&id=9393a6c0&scoped=true&lang=pug&"
import script from "./CustomerTab.vue?vue&type=script&lang=js&"
export * from "./CustomerTab.vue?vue&type=script&lang=js&"
import style0 from "./CustomerTab.vue?vue&type=style&index=0&id=9393a6c0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9393a6c0",
  null
  
)

export default component.exports